import React from 'react'
import { css } from '@emotion/core'
import { HeaderBlock, Body1, Button, colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import sendAnalytics from '../../services/analytics-helper'
import { getExternalBaseUrl } from '../../services/url-service'

const footerContainerCss = css`
  width: 100%;
  background-color: ${colors.background.viewer};
`

const textContainerCss = css`
  max-width: 1000px;
  padding: 40px;
  margin-left: auto;
  margin-right: auto;
`

export default function HomePageFooter(): JSX.Element {
  const [t] = useTranslation()

  return (
    <div css={footerContainerCss}>
      <div css={textContainerCss}>
        <HeaderBlock size="sm" heading={t('ancestors.about-family-search.header', 'About FamilySearch')} />
        <Body1>
          {t(
            'ancestors.about-family-search.description',
            "It's all about family. FamilySearch is a nonprofit family history organization dedicated to connecting families across generations. FamilySearch believes that families bring joy and meaning to life."
          )}
        </Body1>
        <Button
          emphasis="billboard"
          to={`${getExternalBaseUrl()}/register`}
          external
          onClick={() => {
            sendAnalytics({ link_page: 'Home', link_name: 'Footer: Free Account' })
          }}
          data-testid="home-footer-free-account"
        >
          {t('ancestors.free-acount.link', 'Free Account')}
        </Button>
      </div>
    </div>
  )
}
